import React, { useState, useEffect } from 'react';
import { ChevronLeft, Check } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { editUserProfile, fetchUserProfile } from "../../apiservices/ApiService";
var updatedPreferences 
const Fsn40Prefrences = () => {
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();


    const [preferences, setPreferences] = useState({
      timeFormat: '',
      timeZone: '',
      weightUnitPreference: '',
      heightUnitPreference: '',
      distanceUnitPreference: '',
      waterUnitPreference: '',
      userTemperatureUnit: ''
    });
  
    useEffect(() => {
      const fetchUserInfo = async () => {
        try {
          const response = await fetchUserProfile();
  
          // Check for userWeightSelectedUnit or fallback to weightUnitPreference
          const weightUnit = response.userWeightSelectedUnit || response.weightUnitPreference;
  
          setPreferences(prev => ({
            ...prev,
            ...response,
            weightUnitPreference: weightUnit
          }));
  
          console.log(response);
        } catch (error) {
          console.error("Error fetching user info:", error);
        }
      };
  
      fetchUserInfo();
    }, []);

  const [activeDialog, setActiveDialog] = useState(null);

  const displayValues = {
    timeFormat: {
      '12 hours': '12 Hours',
      '24 hours': '24 Hours'
    },
    weightUnitPreference: {
      'kg': 'Kilograms',
      'lbs': 'Pounds'
    },
    heightUnitPreference: {
      'cm': 'Centimeters',
      'mi': 'Feet and Inches'
    },
    distanceUnitPreference: {
      'km': 'Kilometers',
      'mi': 'Miles'
    },
    waterUnitPreference: {
      'lts': 'Milliliters',
      'oz': 'Ounces'
    },
    userTemperatureUnit: {
      '0': 'Celsius (°C)',
      '1': 'Fahrenheit (°F)'
    }
  };

  const pickerOptions = {
    timeFormat: [
      { display: '12 Hours', value: '12 hours' },
      { display: '24 Hours', value: '24 hours' }
    ],
    weightUnitPreference: [
      { display: 'Kilograms', value: 'kg' },
      { display: 'Pounds', value: 'lbs' }
    ],
    heightUnitPreference: [
      { display: 'Centimeters', value: 'cm' },
      { display: 'Feet and Inches', value: 'mi' }
    ],
    distanceUnitPreference: [
      { display: 'Kilometers', value: 'km' },
      { display: 'Miles', value: 'mi' }
    ],
    waterUnitPreference: [
      { display: 'Milliliters', value: 'lts' },
      { display: 'Ounces', value: 'oz' }
    ],
    userTemperatureUnit: [
      { display: 'Celsius (°C)', value: '0' },
      { display: 'Fahrenheit (°F)', value: '1' }
    ]
  };

  const handlePreferenceClick = (type) => {
    if (type === 'timeZone') {
      window.location.href = 'app://open/settings/datetime';
      return;
    }
    setActiveDialog(type);
  };

  const handleSubmit = async (updatedPreferences) => {
    try {
      const response = await editUserProfile(updatedPreferences);
      console.log("Profile updated:", response);
    } catch (error) {
      console.error('Error updating profile:', error);
    }
  };

  const handleCheckClick = () => {
    setIsChecked(!isChecked);
    handleSubmit(updatedPreferences);
  };
  const handleOptionSelect = (type, option) => {
     updatedPreferences = {
      ...preferences,
      [type]: option.value
    };
    console.log("Body - ",updatedPreferences)
    setPreferences(updatedPreferences);
    setActiveDialog(null);

  };

  const PreferenceRow = ({ label, value, onClick }) => (
    <div 
      className="px-4 py-3 border-b border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors"
      onClick={onClick}
    >
      <div className="text-sm font-medium text-gray-900 mb-1">
        {label}
      </div>
      <div className="text-sm text-gray-500">{value}</div>
    </div>
  );

  const Dialog = ({ title, options, onSelect, onClose }) => (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-end sm:items-center justify-center">
      <div className="bg-white w-full max-w-md rounded-t-lg sm:rounded-lg sm:m-4">
        <div className="p-4 border-b border-gray-200">
          <h2 className="text-lg font-medium text-center">{title}</h2>
        </div>
        <div className="max-h-[50vh] overflow-y-auto">
          {options.map((option) => (
            <div
              key={option.value}
              className="px-4 py-3 border-b border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors"
              onClick={() => onSelect(option)}
            >
              {option.display}
            </div>
          ))}
        </div>
        <div 
          className="p-4 text-center text-blue-600 cursor-pointer border-t border-gray-200 hover:bg-gray-50 transition-colors"
          onClick={onClose}
        >
          Cancel
        </div>
      </div>
    </div>
  );

  const getDisplayValue = (type, value) => {
    if (type === 'timeZone') {
      return '+05:30, Asia/Kolkata, India Standard Time';
    }
    return displayValues[type]?.[value] || value;
  };

  const displayOrder = [
    { key: 'timeFormat', label: 'Time Format' },
    { key: 'timeZone', label: 'Time Zone' },
    { key: 'weightUnitPreference', label: 'Weight Unit' },
    { key: 'heightUnitPreference', label: 'Height Unit' },
    { key: 'distanceUnitPreference', label: 'Distance Unit' },
    { key: 'waterUnitPreference', label: 'Water Unit' },
    { key: 'userTemperatureUnit', label: 'Temperature Unit' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white  shadow sticky top-0 z-10">
      <div className="flex items-center justify-between px-4 py-3 max-w-3xl mx-auto relative">
      {/* Back Button */}
      <ChevronLeft
        className="w-6 h-6 text-gray-600 cursor-pointer  left-4"
        onClick={() => navigate(-1)} // Navigates back 1 screen
      />

      {/* Title */}
      <span className="text-xl mx-auto">Preferences</span>

      {/* Check Icon */}
      <Check
        className={`w-6 h-6 cursor-pointer  right-4 ${
          isChecked ? "text-green-600" : "text-gray-600"
        } `}
        onClick={  handleCheckClick }
      />
    </div>
      </div>

      <div className="mt-4 bg-white max-w-3xl mx-auto">
        {displayOrder.map(({ key, label }) => (
          <PreferenceRow
            key={key}
            label={label}
            value={getDisplayValue(key, preferences[key])}
            onClick={() => handlePreferenceClick(key)}
          />
        ))}
      </div>

      {activeDialog && (
        <Dialog
          title={displayOrder.find(({ key }) => key === activeDialog)?.label || ''}
          options={pickerOptions[activeDialog] || []}
          onSelect={(option) => handleOptionSelect(activeDialog, option)}
          onClose={() => setActiveDialog(null)}
        />
      )}
    </div>
  );
};

export default Fsn40Prefrences;
